module.exports = __webpack_public_path__ + "media/configurations/SX-P-5a6eec89.png";